import { render } from "./SelectJourney.vue?vue&type=template&id=3ef640b2&scoped=true&lang=pug"
import script from "./SelectJourney.vue?vue&type=script&lang=ts"
export * from "./SelectJourney.vue?vue&type=script&lang=ts"

import "./SelectJourney.vue?vue&type=style&index=0&id=3ef640b2&lang=css"
import "./SelectJourney.vue?vue&type=style&index=1&id=3ef640b2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3ef640b2"

export default script